
import { childMixin } from 'vux/src/mixins/multi-items'

export default {
name: 'TabItem',
mixins: [childMixin],
props: {
activeClass: String,
disabled: Boolean,
badgeBackground: {
type: String,
default: '#f74c31'
},
badgeColor: {
type: String,
default: '#fff'
},
badgeLabel: String
},
computed: {
style () {
return {
borderWidth: this.$parent.lineWidth + 'px',
borderColor: this.$parent.activeColor,
color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
border: this.$parent.animate ? 'none' : 'auto'
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/Tab/TabItem.vue